var _rect, _rect2, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 335,
    height: 195,
    viewBox: "0 0 335 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2a2a40",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a1a2e",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#cardGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 325,
    height: 185,
    fill: "none",
    stroke: "#444",
    strokeWidth: 2,
    strokeDasharray: "8,4"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 167.5,
    y: 80,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fill: "#666",
    textAnchor: "middle"
  }, "MISSING")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 167.5,
    y: 105,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fill: "#666",
    textAnchor: "middle"
  }, "GAME CARD")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 167.5,
    y: 145,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#444",
    textAnchor: "middle"
  }, "DEV MODE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderCard);
export default __webpack_public_path__ + "static/media/placeholder-card.e4feee49a6af183141303dc8e4184fd0.svg";
export { ForwardRef as ReactComponent };